<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { openModal } from 'svelte-modals';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import SearchInput from '../../shared/SearchInput.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import { mainMenu } from '../../../stores/store';
    import { app } from '../../../stores/app';
    import ModalAddUser from './ModalAddUser.svelte';
    import UserPermissionsList from './UserPermissionsList.svelte';
    import type { PanelUserType } from './UserPermissionsApi';

    let query: string = '';
    /** Instancja listy - modal oddaje jej gotowy wiersz zamiast wymuszać ponowne pobranie całości. */
    let list: UserPermissionsList | null = null;

    /** Modal oddaje wiersz zwrócony przez createUser(); lista dokłada go u siebie. */
    function openAddUser(): void {
        openModal(ModalAddUser, {
            onCreated: (user: PanelUserType) => list?.addUser(user),
        });
    }

    // pozycja menu jest odsłaniana tylko managerom, ale strona pilnuje tego również sama -
    // wejście bezpośrednio na adres nie może pokazać listy użytkowników
    $: isUserManager = $app.permissions?.isUserManager === true;

    onMount(() => {
        $mainMenu.currentPage = 'PageUserPermissions';
    });
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio>
            <div slot="main-header">
                {$_('User permissions')}
            </div>
            <div slot="main-search">
                {#if isUserManager}
                    <SearchInput
                        placeholder={$_('Search')}
                        {query}
                        onKeyup={value => {
                            query = value;
                        }}
                    />
                {/if}
            </div>
            <div slot="main-buttons">
                {#if isUserManager}
                    <ButtonAddSomething text={$_('Add user')} on:click={openAddUser} />
                {/if}
            </div>
        </TemplateHeaderTrio>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="overflow-y: auto; flex: 1; display: flex; flex-direction: column;">
        <div style="margin: 20px 0; overflow-y: auto; flex: 1; display: flex; flex-direction: column;">
            {#if isUserManager}
                <UserPermissionsList bind:this={list} {query} />
            {:else}
                <MessageDanger error={$_('Access denied - check your permissions')} />
            {/if}
        </div>
    </div>
</TemplateStandard>
